// Parses a locale-formatted money string into minor units (cents), without
// caring whether the user used a US, EU, Swiss, or space-separated format.
//
// Returns null for empty / unparseable input. Returns a negative number when
// the input begins with a minus sign so callers can clamp it against data-min.
//
// Treats the trailing group after the last separator as the decimal portion
// only when it is short enough (<= precision digits); otherwise the separator
// is a thousands separator.
const SEPARATOR = /[.,'\s]/g;

export default function parseLocaleMoney(value, precision) {
  if (value == null) return null;
  const p = precision == null ? 2 : precision;

  const raw = String(value).trim();
  const sign = raw.charAt(0) === '-' ? -1 : 1;
  const cleaned = raw.replace(/[^\d.,'\s]/g, '');
  if (cleaned === '') return null;

  const matches = [];
  let m;
  while ((m = SEPARATOR.exec(cleaned)) !== null) matches.push(m.index);
  SEPARATOR.lastIndex = 0;

  let integerPart = cleaned;
  let decimalPart = '';

  if (matches.length > 0) {
    const lastIdx = matches[matches.length - 1];
    const trailing = cleaned.slice(lastIdx + 1);
    if (/^\d+$/.test(trailing) && trailing.length > 0 && trailing.length <= p) {
      integerPart = cleaned.slice(0, lastIdx);
      decimalPart = trailing;
    }
  }

  integerPart = integerPart.replace(SEPARATOR, '');
  if (integerPart === '') integerPart = '0';
  decimalPart = decimalPart.padEnd(p, '0').slice(0, p);

  const minor = parseInt(integerPart + decimalPart, 10);
  if (Number.isNaN(minor)) return null;
  return sign * minor;
}
